<template>
  <div class="pg-main-layout">
    <SimpleNavbar />
    <div class="pg-main-layout__content">
      <div class="content__page">
        <component
          v-if="subLayoutData"
          :is="getSubLayoutComponent"
          :layoutProps="getSubLayoutProps"
          :subLayoutData="getChildLayoutData"
        >
          <slot></slot>
        </component>
        <slot v-else></slot>
      </div>
      <Footer />
    </div>
    <LoginModal
      v-if="loginModalShow"
      @toggleLoginModal="toggleLoginModal"
      @toggleRegisterModal="toggleRegisterModal"
      :redirectPath="redirectPath"
    />
    <RegisterModal
      v-else-if="guestModalShow"
      @toggleLoginModal="toggleLoginModal"
      @toggleRegisterModal="toggleRegisterModal"
      :redirectPath="redirectPath"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import BlankLayout from "@/layouts/BlankLayout.vue"
import Footer from "../components/footer/Footer"
import SimpleNavbar from "../components/navigation/SimpleNavbar"
export default {
  components: {
    Footer,
    SimpleNavbar,
    LoginModal: () => import("@/components/auth/LoginModal"),
    RegisterModal: () => import("@/components/auth/RegisterModal"),
  },
  props: {
    layoutProps: {
      type: Object,
      default: () => {
        return {}
      },
    },
    subLayoutData: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {
      redirectPath: this.$router.path,
    }
  },
  computed: {
    ...mapGetters("User", ["getUser", "isUserPro"]),
    ...mapGetters("Store", ["loginModalShow", "guestModalShow"]),
    getSubLayoutComponent () {
      return this.$_.get(this.subLayoutData, "component") || BlankLayout
    },
    getSubLayoutProps () {
      return this.$_.get(this.subLayoutData, "props")
    },
    getChildLayoutData () {
      return this.$_.get(this.subLayoutData, "child")
    },
  },
  methods: {
    ...mapMutations("Store", ["setLoginModalShow", "setGuestModalShow"]),
    toggleLoginModal () {
      this.setLoginModalShow(!this.loginModalShow)
    },
    toggleRegisterModal () {
      this.setGuestModalShow(!this.guestModalShow)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/_variables.scss";
@import "@/assets/style/_mixins.scss";

$top-navbar-height: 5.5rem;
$side-navbar-width: 23rem;

.pg-main-layout {
  background-color: $gray;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;

  .pg-main-layout__navbar {
    position: relative;
  }

  .pg-main-layout__content {
    position: relative;
    top: $top-navbar-height;
    &.with-pro-banner {
      top: 11rem;
    }
  }

  .pg-main-layout__content {
    display: flex;
    flex-direction: column;
    // overflow-y: auto;
    flex: 1 1 auto;

    .content__page {
      flex: 1 1 auto;
    }

    .content__footer {
      flex: 0 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/SimpleLayout.vue